import { Box } from '@mui/material';
import { exportColours } from 'apiCalls/apiCalls';
import { PrimaryButton } from 'components/Buttons';
import { ErrorMessage, Loading, SubHeading, SuccessMessage } from 'components/CommonComponents';
import { Grid } from 'components/Grid';
import { Modal } from 'components/Modal';
import { writeToFile } from 'helpers/writeToFile';
import { PAD_SMALL } from 'providers/designSystem';
import { useState } from 'react';

const ExportModal = ({ isOpen, setIsOpen }) => {
    const [pending, setPending] = useState(false);
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleClick = async () => {
        setPending(true);
        try {
            const data = await exportColours();
            writeToFile(data);

            setPending(false);
            setSuccess(true);
        } catch (error) {
            setError(true);
            setPending(false);
        }
    };

    return (
        <Modal open={isOpen} onClose={handleClose} width="50vw" height="50vh" title="Export Colours">
            <Grid numberOfColumns={1}>
                {pending && <Loading />}
                {error && <ErrorMessage />}
                {success && <SuccessMessage message="Colours Exported Successfully" />}
                {!pending && !error && !success && <PrimaryButton onClick={handleClick}>Export</PrimaryButton>}
            </Grid>
        </Modal>
    );
};
export const ExportColours = () => {
    const [isOpen, setIsOpen] = useState(false);

    const openExportModal = () => {
        setIsOpen(true);
    };

    return (
        <Box display={'grid'} gap={PAD_SMALL}>
            <SubHeading>Backup</SubHeading>
            <PrimaryButton onClick={openExportModal}>Export Colours</PrimaryButton>
            {isOpen && <ExportModal isOpen={isOpen} setIsOpen={setIsOpen} />}
        </Box>
    );
};
